import React from 'react';
import { Text } from '@pixi/react';

function GambleText({ x, y, text, style }) {
  return <Text x={x} y={y} text={text} anchor={0.5} style={style} resolution={2} />;
}
export default GambleText;
